<template>
	<div class="xkit-datatable-wrapper" :id="wrapper_id">
		<table class="table">
			<thead>
				<tr>
					<th v-for="col in state.columns">{{ col }}</th>
					<th class="actions">
						<span class="add-new-wrapper" v-html="state.add_new_button"></span>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr class="dt-row"
					v-for="row in sorted_row"
					:data-id="row.id"
				    :key="row.id"
				>
					<td v-for="[ col_key, col ] in Object.entries( state.columns )"><span v-html="row[col_key]"></span></td>
					<td class="actions">
						<template v-for="[ key, button ] in Object.entries( state.actions )">
							<span class="action-wrapper" v-if="row.actions[key] != false" v-html="button"></span>
						</template>
					</td>
				</tr>
			</tbody>
		</table>
		<Pagination :found_posts="pagination.found_posts" :limit="pagination.limit" :current="pagination.current" :go_to_page="go_to_page" />
	</div>
</template>
<script setup>
import  { useDataTableStore } from "../stores/store-datatable";
import  Pagination from "../partials/_pagination.vue";
import {computed, nextTick, onMounted, ref} from "vue";
import api from "../../../../vendor/xkit/js/api";

const store = useDataTableStore()

let $ = jQuery
const props = defineProps({
	state: Object,
	wrapper_id: String,
})

let wrapper_id = 'xkit-datatable-wrapper' + props.wrapper_id
let $wrapper = null
// let rows = ref( {} )

store.datatables[props.wrapper_id] = {
	state: props.state,
	wrapper_id,
	rows: {},
	pagination: {
		// found_posts: 0, limit: 20, current: 1,
	}
}

// let pagination = storeToRefs( store.datatables[props.wrapper_id].pagination )
// let pagination = store.datatables[props.wrapper_id].pagination
let pagination = computed( () => {
	return store.datatables[props.wrapper_id].pagination
})


// const { rows } = storeToRefs(store.datatables[props.wrapper_id])
// let rows =  store.datatables[props.wrapper_id].rows
let sorted_row = computed( () => {
  let items = Object.entries( store.datatables[props.wrapper_id].rows ).map( i => i[1])
  items = items.sort( (a, b) =>  a.order < b.order ? -1 : 1 )
  return items;
})

onMounted(async function () {
	$wrapper = $( '#' + wrapper_id)
	store.datatables[props.wrapper_id].$wrapper = $wrapper

	await store.fetch_data(props.wrapper_id)

	if ( window.init_xkit_modals && $('[data-xkit-open-modal]').length ) {
		init_xkit_modals()
	}

	$wrapper.on( 'click', '.dt-row .actions .action', async function(e) {
		if ( e.isDefaultPrevented() ) {
			return;
		}
		e.preventDefault()
		let $action_button = $(this)
		let $row = $action_button.parents('.dt-row').first()
		let row_id = $action_button.data('id')

		if ( $action_button.attr( 'data-action' ) ) {

			XKIT_Utils.blockUI( $row )

			let res = await api.post( $action_button.data() )

			$row.unblock()
			if ( res.data.err ) {
				XKIT_Utils.toast( { message: res.data.html, type: 'error' } )
				return;
			}

			if ( res.data.remove && ! res.data.refresh ) {
				$row.remove()
			}

			if ( res.data.refresh ) {
				store.fetch_data(props.wrapper_id)
			}
			if ( res.data.updated_row ) {
				rows[row_id] = res.data.item
			}
		}
	})

	let registered_modals = []
	$( '[data-xkit-open-modal]', $wrapper ).each(function () {
		let modal_id = $( this ).data( 'xkit-open-modal' )
		if ( registered_modals.includes( modal_id ) ) {
			return
		}
		registered_modals.push( modal_id )
		$(document).on( 'xkit-before-close-modal', function( e, { $modal, posted_data, res } ) {
			if ( $modal.attr( 'id') == 'xkit-modal-' + modal_id ) {
				if ( res.data.reload || res.data.refresh ) {
					e.preventDefault()
					store.fetch_data(props.wrapper_id)
					bootstrap.Modal.getOrCreateInstance($modal[0]).hide()
				}
			}
		})
	})
})

let go_to_page = async function( page, current ) {
	const url = new URL( location );
	url.searchParams.set( "pagenum", page );

	history.pushState( { pagenum: page }, "", url );

	await store.fetch_data(props.wrapper_id, { pagenum: page })
}


</script>